/* eslint-disable import/no-mutable-exports */
var init = {
  init: function () {




	/* Start JQuery_PlugIn_a11y */
	(function($){
	// jQuery plugin which allows to mimic the user's sequential keyboard-navigation with the TAB-key
	// Copyright (c) 2011 Oliver Siemoneit - oliver.siemoneit@web.de
	// Licensed under the MIT license: http://www.opensource.org/licenses/mit-license.php
	// Usage: $('#myDialogDiv').getFocusableElements();           --> returns tab-order of 'myDialogDiv'
	//      $('#myDialogDiv').getFirstFocusableElement();         --> returns first element in the tab-order
	//      $('#myDialogDiv').getLastFocusableElement();          --> returns last element in the tab-order
	//      $('#myDialogDiv').getNextFocusableElement($('#mylink'));    --> returns next element in tab-order after 'mylink'
	//      $('#myDialogDiv').getPreviousFocusableElement($('#mylink'));  --> returns previous element in the tab-order
	//      $('#myDialogDiv').getFocusableElements('clearCache');     --> Clear cache, rebuild tab-order and return it
	//
	// Note:  All the above functions use a cache to speed up processing time. You could force to update the cache with the 'clearCache' parameter.
	//      "$([]).getFocusableElements();" empties the cache.
	//
	  function buildTabOrder ($blockLevelElement) {
	    // Get focusable elements (http://dev.w3.org/html5/spec/editing.html#sequential-focus-navigation-and-the-tabindex-attribute)
	    var $focusable = $blockLevelElement.find('a, button, input, textarea, select, iframe, area, command, [tabindex]').not('[disabled], :hidden');
	          
	    // Remove elements styled "visibility:hidden" and "visibility:collapsed"
	    $focusable = $focusable.map(function() {
	      var $this = $(this);
	      return $this.css('visibility') === 'hidden' || $this.css('visibility') === 'collapsed'  ? null : this;
	    });
	  
	    // Remove anchors
	    $focusable = $focusable.map(function() {
	      var $this = $(this);
	      return $this.attr('href') === undefined && $this.is('a') ? null : this;
	    });
	    
	    // Remove elements with a negative tabindex
	    $focusable = $focusable.map(function() {
	      return parseInt($(this).attr('tabindex')) < 0 ? null : this;
	    });
	    // Build tab-order
	    // - Disregard tabindex=""
	    // - Treat tabindex="0" as if no tabindex has been specified
	    // - Maximum value for tabindex allowed (according to w3c): 32767
	    // - Tabindex > 32767 is 'no tabindex'
	    $focusable = $focusable.sort(function(a, b) {
	      var $a = $(a), $b = $(b), indexA = 32768, indexB = indexA;
	      
	      if (parseInt($a.attr('tabindex')) > 0) {
	        indexA = parseInt($a.attr('tabindex'));
	        if ( indexA > 32767 ) {
	          indexA = 32768;
	        }
	      }
	      
	      if (parseInt($b.attr('tabindex')) > 0) {
	        indexB = parseInt($b.attr('tabindex'));
	        if ( indexB > 32767 ) {
	          indexB = 32768;
	        }
	      }
	      
	      return ((indexA < indexB) ? -1 : ((indexA > indexB) ? 1 : 0));
	    });
	    // Cache tab-order
	    $(document).data('tabOrderCache', {
	      $element   :  $blockLevelElement,
	      $tabOrder  :  $focusable
	    });
	  }
	  $.fn.extend ({
	  
	    getFocusableElements: function (options) {
	      var $document = $(document), cache = $document.data('tabOrderCache') || { $element: $([]), $tabOrder: [] };
	    
	      if (options === 'clearCache' || this.get(0) !== cache.$element.get(0)) {
	        buildTabOrder(this);
	        cache = $document.data('tabOrderCache');
	      }
	    
	      return cache.$tabOrder;
	    },
	  
	    getFirstFocusableElement: function (options) {
	      var $document = $(document), cache = $document.data('tabOrderCache') || { $element: $([]), $tabOrder: [] };
	    
	      if (options === 'clearCache' || this.get(0) !== cache.$element.get(0)) {
	        buildTabOrder(this);
	        cache = $document.data('tabOrderCache');
	      }
	    
	      if (cache.$tabOrder.length === 0) {
	        return $([]);
	      }
	      return cache.$tabOrder.eq(0);
	    },
	    getLastFocusableElement: function (options) {
	      var $document = $(document), cache = $document.data('tabOrderCache') || { $element: $([]), $tabOrder: [] };
	    
	      if (options === 'clearCache' || this.get(0) !== cache.$element.get(0)) {
	        buildTabOrder(this);
	        cache = $document.data('tabOrderCache');
	      }
	    
	      if (cache.$tabOrder.length === 0) {
	        return $([]);
	      }
	      return cache.$tabOrder.eq(cache.$tabOrder.length-1);
	    },
	    getNextFocusableElement: function (options) {
	      var $document = $(document), cache = $document.data('tabOrderCache') || { $element: $([]), $tabOrder: [] };
	    
	      if (arguments[1] === 'clearCache' || this.get(0) !== cache.$element.get(0)) {
	        buildTabOrder(this);
	        cache = $document.data('tabOrderCache');
	      }
	    
	      var me = cache.$tabOrder.index(arguments[0]);
	      if (me < 0) {
	        return $([]);
	      }
	     
	      return (me+1) < cache.$tabOrder.length ? cache.$tabOrder.eq(me+1) : $([]);
	    },
	    getPreviousFocusableElement: function (options) {
	      var $document = $(document), cache = $document.data('tabOrderCache') || { $element: $([]), $tabOrder: [] };
	    
	      if (arguments[1] === 'clearCache' || this.get(0) !== cache.$element.get(0)) {
	        buildTabOrder(this);
	        cache = $document.data('tabOrderCache');
	      }
	    
	      var me = cache.$tabOrder.index(arguments[0]);
	      if (me < 0) {
	        return $([]);
	      }
	     
	      return (me-1) > -1 ? cache.$tabOrder.eq(me-1) : $([]);
	    }
	  });
	 
	      
	    $.fn.extend({
	      addAria: function(settings){
	        settings = jQuery.extend({
	          live:'false',
	          widget:''
	        },settings);
	        $elem = $(this);
	        switch (settings.widget){
	        case  'lightbox':
	          $elem.setRole().attr('aria-labelledby','lightbox-image-details-caption');
	          if(settings.live === true){
	            $elem.attr('aria-live', 'assertive');
	          };
	          break;
	         default: break;
	        }
	      },
	      setRole: function(){
	        return $elem.attr('role','dialog');
	      }
	    });  
	})(jQuery);
	/* Ende JQuery_PlugIn_a11y */

	/* Start Addon_AdressParser */
	/*
	*/
	$.fn.parseAdress = function() {
	 var telExpr = /([^\d\.\:]|^)((\+|\(0|0){1}\d+([\(\) \-/]*\d+){1}([\(\) \-/]*\d+)+)/gim;
	 var el = this.find('p:not(.formHandle,.formError)');
	 $.each(el, function(i,v) {
	  var inputText = $(v).html();
	  if (inputText && inputText.match(telExpr)) {
	   var replacedText = inputText;
	   replacedText = replacedText.replace(telExpr, '$1<a href="tel:$2">$2</a>');
	   $(v).html(replacedText);
	  }
	 });
	 var address = this.find('address, .address');
	 $.each(address, function(i,v) {
	  var maps = 'http://maps.google.de/maps';
	  var q = '?q='+trimAndEncode($(v).text());
	  var a = $('<a target="_blank">');
	  $(a).attr('target','_blank');
	  $(a).attr('href',maps+q);
	  $(v).wrapInner(a);
	 });
	};
	function trimAndEncode(text) {
	 return encodeURI(text.replace(/^(\s*)|(\s*)$/g, '').replace(/\s+/g, ' '));
	};
	/* Ende Addon_AdressParser */




  }
};

export default init;